/**
 * BEKRA Lösungen — lightweight arrow + drag carousel.
 * Native scroll-snap does the actual scrolling; this only translates
 * arrow clicks into scrollBy() calls and adds optional desktop mouse-drag.
 * No external library, no per-card IntersectionObserver (reveal motion is
 * handled once at the section root via the shared <bekra-scroll-reveal>).
 */
(function () {
  'use strict';

  class BekraSolutionsCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-solutions-track]');
      this.prevBtn = this.querySelector('[data-solutions-prev]');
      this.nextBtn = this.querySelector('[data-solutions-next]');
      if (!this.track) return;

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.scrollByStep(-1));
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.scrollByStep(1));
      }

      this.track.addEventListener('scroll', () => this.updateArrowState(), { passive: true });
      window.addEventListener('resize', () => this.updateArrowState());
      this.updateArrowState();

      this.bindDrag();
    }

    stepSize() {
      var item = this.track.querySelector('.bekra-solutions__item');
      if (!item) return this.track.clientWidth;
      var gap = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap) || 16;
      return item.getBoundingClientRect().width + gap;
    }

    scrollByStep(direction) {
      this.track.scrollBy({ left: this.stepSize() * direction, behavior: 'smooth' });
    }

    updateArrowState() {
      var max = this.track.scrollWidth - this.track.clientWidth - 2;
      var pos = this.track.scrollLeft;
      if (this.prevBtn) this.prevBtn.disabled = pos <= 2;
      if (this.nextBtn) this.nextBtn.disabled = max <= 0 || pos >= max;
    }

    bindDrag() {
      var track = this.track;
      var isDown = false;
      var startX = 0;
      var startScroll = 0;
      var moved = false;

      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return; // native touch scrolling handles this
        isDown = true;
        moved = false;
        startX = e.clientX;
        startScroll = track.scrollLeft;
        track.classList.add('is-dragging');
      });

      track.addEventListener('pointermove', function (e) {
        if (!isDown) return;
        var delta = e.clientX - startX;
        if (Math.abs(delta) > 3) moved = true;
        track.scrollLeft = startScroll - delta;
      });

      function endDrag() {
        if (!isDown) return;
        isDown = false;
        track.classList.remove('is-dragging');
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointerleave', endDrag);

      // Prevent the drag gesture from also triggering the card's link click.
      track.addEventListener(
        'click',
        function (e) {
          if (moved) {
            e.preventDefault();
            moved = false;
          }
        },
        true
      );
    }
  }

  if (!customElements.get('bekra-solutions-carousel')) {
    customElements.define('bekra-solutions-carousel', BekraSolutionsCarousel);
  }
})();
